import { render, staticRenderFns } from "./areacodePanel.vue?vue&type=template&id=37222a63&"
import script from "./areacodePanel.vue?vue&type=script&lang=ts&"
export * from "./areacodePanel.vue?vue&type=script&lang=ts&"
import style0 from "./areacodePanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports